import mutations from './moduleDonorsMutations.js'
import actions from './moduleDonorsActions.js'
import getters from './moduleDonorsGetters.js'

const getDefaultState = () => {
  return {
    lastUpdate: 0,
    donorsState: null,//null, loading, ready
    donors: [],
    genders: [],
    gendersLastUpdate: 0,
    contactStatsState: null,//null, loading, ready
    contactStats: null,
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions,
  getters
}

